import React from 'react'
import { Tooltip } from 'react-tooltip'

import EditIcon from '@mui/icons-material/Edit';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import imgBG from "../../assets/imagens/bg_decklist.jpg";

import img_base_thallarse from "../../assets/imagens/base_card_thallarse.png";

import img_detalhe_imag from "../../assets/imagens/base_frente_img.png";
import img_placeHouder from "../../assets/imagens/vincentMob - Copia.jpg";

import { useCardBuildHook } from './hook';
const CardBuild = () => {

    const {
        isOpenDeck,
        toggleDrawerDeck,
        is_descktop
    } = useCardBuildHook();
    return (
        <div style={{ backgroundImage: `url(${imgBG})`, }} className='h-full w-full bg-cover bg-center flex justify-center md:justify-end items-cente overflow-hidden'>
            <div className={`${isOpenDeck ? 'md:mr-[320px] duration-200' : 'mr-0 duration-200'} bg-slate-700 bg-opacity-[94%] w-full h-full pt-16 transition-all  `}>

                <div className='flex justify-end px-5 pt-2'>
                    <div className='px-4 bg-slate-500 hover:bg-slate-400 text-right w-10 h-10 flex justify-center items-center cursor-pointer rounded' onClick={() => { toggleDrawerDeck(!isOpenDeck) }} data-tooltip-delay-show={500} data-tooltip-id="filter" data-tooltip-content="Abrir Editor" data-tooltip-place="bottom"><Tooltip id="filter" className='z-50' /><EditIcon></EditIcon></div>
                </div>
                <div className={`${is_descktop ? 'items-center' : 'items-start'} w-full h-full flex justify-center `}>
                    <div id="Card" className='bg-blue-500 min-w-[400px] w-[400px] h-[550px] relative'>

                        <img className='w-[310px] h-[227px] object-cover absolute top-[59px] left-[45px]' src={img_placeHouder}></img>
                        <img className='w-[13%] absolute top-[59px] left-[34px]' src={img_detalhe_imag}></img>
                        <img src={img_base_thallarse}></img>

                    </div>
                </div>



                <aside className={`${isOpenDeck ? 'translate-x-0 duration-200' : ' duration-300 translate-x-full '} overflow-x-visible bg-slate-700  pt-16 transition-transform  fixed top-0 right-0 z-30 w-80 h-screen shadow-lg flex flex-col p-3 border-l border-slate-600 border-opacity-60`}>


                    <div className='flex flex-col justify-start overflow-y-auto  scrollbar-thin overflow-x-hidden scrollbar-thumb-slate-600  scrollbar-rounded-sm pr-2 h-full pt-4'>
                        <div className='flex justify-between w-full mb-4'>


                            <div className='rounded-full w-7 h-7 flex justify-center items-center bg-slate-600 hover:bg-opacity-75 cursor-pointer' onClick={() => { toggleDrawerDeck(false) }}><CloseRoundedIcon></CloseRoundedIcon>
                            </div>

                        </div>



                        asasass
                    </div>
                </aside>
            </div>
        </div>
    )
}

export default CardBuild